module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-52.76fb8278.svg";